import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { required } from '@ubeya/shared/utils/form';
import { FlexSpace, FormModal, InputField, SelectField } from '@ubeya/shared-web/components';
import { responsiveFields } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import Color from './Color';

const Container = styled(FlexSpace)`
  ${responsiveFields.mobile};
`;

const TagsModal = ({ selectedTag, onClose, onConfirm, colorsOptions, mappedColors, totalTags = 0 }) => {
  const { t } = useContext(ConfigContext);

  const tempSelectedTag = useMemo(
    () => ({
      ...selectedTag,
      color: selectedTag?.color ? Number(selectedTag.color) : colorsOptions[totalTags % colorsOptions.length].value
    }),
    [colorsOptions, selectedTag, totalTags]
  );

  const initialValues = useMemo(() => ({ title: undefined, ...tempSelectedTag }), [tempSelectedTag]);

  return (
    <FormModal
      initialValues={initialValues}
      onSubmit={(values) => {
        onConfirm(values);
        onClose();
      }}
      size="small"
      onClose={onClose}
      title={selectedTag.id ? t('editTag') : t('addTag')}
      showCancelButton
      disabledOnPristine={false}>
      <Container>
        <InputField name="title" title={t('name')} autoFocus validate={required} />

        <SelectField
          name="color"
          title={t('color')}
          options={colorsOptions}
          formatValue={({ value }) => <Color color={mappedColors[value]} />}
          formatOption={({ value }) => ({ value, label: <Color color={mappedColors[value]} /> })}
          isMulti={false}
          usePortal
        />
      </Container>
    </FormModal>
  );
};

export default TagsModal;
